<div class="parent" *ngIf="!isHandset else mobileTemplate">
  <!-- <div class="gridTitle"><div class="innerGridTitle rotateText">Keywords</div></div> -->
  <div class="grid">
    <span class="columnHeader" *ngFor="let t of columns">
      {{ t }}
    </span>
  </div>
  <div class="grid gridRow" *ngFor="let k of data">

    <span class="pertinent">{{ unitArmies[k.army] }}</span>
    <span class="pertinent">{{ writeOrdinalSuffix(k.corps) }}</span>
    <span class="pertinent">{{ writeOrdinalSuffix(k.regimentNo?.regimentNo) }}</span>
    <span class="pertinent">{{ k.state?.abbreviation }}</span>
    <span class="pertinent">{{ k.branch?.branchName }}</span>
    <span>{{ k.companyLetters }}</span>

  </div>
</div>
<div class="recordCount" *ngIf="data?.length; else noData">
  {{ data.length }} unit record(s)
</div>
<ng-template #noData>
  <div class="recordCount">We don't have any Units for this record.</div>
</ng-template>



<ng-template #mobileTemplate>
      <table class="mobile-table">
        <thead class="mobile-header">
          <tr>
            <th *ngFor="let t of columns">{{ t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let k of mobileData">
            <!-- <td class="pertinent">{{ unitArmies[k.army] }}</td>
            <td class="pertinent">{{ writeOrdinalSuffix(k.corps) }}</td>
            <td class="pertinent">{{ writeOrdinalSuffix(k.regimentNo?.regimentNo) }}</td>
            <td class="pertinent">{{ k.state?.abbreviation }}</td>
            <td class="pertinent">{{ k.branch?.branchName }}</td>
            <td>{{ k.companyLetters }}</td> -->
            <td class="pertinent">{{k}}</td>
          </tr>
        </tbody>
      </table>
</ng-template>